import { render } from "./App.vue?vue&type=template&id=7f628a64"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7f628a64&lang=css"

import exportComponent from "C:\\go-work\\src\\Enigma\\Music_Of_The_Spheres\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__